import React, { Component } from 'react';
import dynamicImport from '../common/dynamicImport';
import classNames from 'classnames';
import NodeInput from './NodeInput';
import { injectIntl } from 'react-intl';
import { messages } from  '../common/Translations';

export class NodeContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false
        };
        this.initialTitle = props.rowInfo.node.title;
        this.title = this.initialTitle;
    }

    onEditingStarted() {
        this.setState({ editing: true });
        this.props.onEditingStarted && this.props.onEditingStarted();
    }

    onEditingConfirmed(value) {
        this.title = value;

        const updatedNode = {...this.props.rowInfo.node, ...{title: value}};

        const updatedTree = this.props.modules.sortableTree.changeNodeAtPath({
            treeData: this.props.treeData,
            path: this.props.rowInfo.path,
            newNode: updatedNode,
            getNodeKey: ({node: treeNode, treeIndex: treeIndex}) => treeIndex,
            ignoreCollapsed: false
        });
        let params = {
            name: value,
            id: this.props.rowInfo.node.id,
            parentId: this.props.rowInfo.node.parentId
        };
        this.props.onEditingConfirmed && this.props.onEditingConfirmed(updatedTree, params);
        this.setState({ editing: false })
    }

    renderButtons() {
        const editBtn = (
            <input
                type="button"
                role="button"
                value={this.props.intl.formatMessage(messages.categoriesWebmasterTreeNodeEditBtn)}
                onClick={() => this.setState({ editing: true })}
                className={classNames("btn", "btn-info", "btn-sm", "mr-1")}
            />
        );

        const rmBtn = (
            <button
                type="button"
                role="button"
                value={this.props.intl.formatMessage(messages.categoriesWebmasterTreeNodeDeleteBtn)}
                onClick={() => this.props.onDelete(this.props.rowInfo)}
                className={classNames("btn", "btn-danger", "btn-sm")}
            >
                <i className="fa fa-times-circle" aria-hidden="true" />
                {' '}
                Slet
            </button>
        );

        return (
            <div className={'node-content__action-buttons'}>
                {editBtn}
                {rmBtn}
            </div>
        );
    }

    renderUntouched() {
        return (
            <div
                className={'node-content'}
                onDoubleClick={this.onEditingStarted.bind(this)}
            >
                {this.title}
                {this.renderButtons()}
            </div>
        );
    }

    render() {
        return (
            <div>
                {
                    this.state.editing ?
                    <NodeInput
                        initialValue={this.title}
                        onComplete={this.onEditingConfirmed.bind(this)}
                        onEditingCanceled={() => this.setState({ editing: false })}
                    /> :
                    this.renderUntouched()
                }
            </div>
        );
    }

}

const imports = { sortableTree: import(/* webpackChunkName: "react-sortable-tree" */'react-sortable-tree') };

export default injectIntl(dynamicImport(NodeContent, imports));


// WEBPACK FOOTER //
// ./web/src/components/categories/NodeContent.jsx